import classNames from 'classnames';

import css from './PayuLogo.module.css';

const PayuLogo = ({ rootClassName, className }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="120.9px"
    height="43px"
    viewBox="0 0 120.9 43"
    className={classNames(css.root || rootClassName, className)}
  >
    <g>
      <path
        fill="currentColor"
        d="M73.7,16c-0.6,0-1-0.4-1-1v-4.4h-0.4c-2.3,0-3.1,0.4-3.1,2.5V18l0,0v1v0.1V26c0,0.8-0.2,1.5-0.5,2
            c-0.6,1-1.9,1.4-3.8,1.4c-2,0-3.2-0.4-3.8-1.4c-0.3-0.5-0.5-1.2-0.5-2v-6.8v-0.1V18l0,0v-4.9c0-2.1-0.8-2.5-3.1-2.5h-0.7
            c-2.3,0-3.1,0.4-3.1,2.5V26c0,2.1,0.5,3.8,1.4,5.2c1.7,2.7,5.1,4.2,9.9,4.2l0,0l0,0c4.8,0,8.2-1.5,9.9-4.2c0.9-1.4,1.4-3.2,1.4-5.2
            V16H73.7L73.7,16z"
      />
      <path
        fill="currentColor"
        d="M80.5,3.6h3.8c0.4,0,0.7,0.3,0.7,0.7v3.8c0,0.4-0.3,0.7-0.7,0.7h-3.8c-0.4,0-0.7-0.3-0.7-0.7V4.3
            C79.8,3.9,80.1,3.6,80.5,3.6z"
      />
      <path
        fill="currentColor"
        d="M76.7,0h2.6c0.3,0,0.5,0.2,0.5,0.5v2.6c0,0.3-0.2,0.5-0.5,0.5h-2.6c-0.3,0-0.5-0.2-0.5-0.5V0.5
            C76.2,0.2,76.5,0,76.7,0z"
      />
      <path
        fill="currentColor"
        d="M9.7,10.6H4.2c-2.9,0-4.2,1.3-4.2,4.2v18.8c0,1.1,0.4,1.5,1.5,1.5h0.4c1.1,0,1.5-0.4,1.5-1.5v-7.3h6.3
            c5.6,0,8.3-2.5,8.3-7.9S15.3,10.6,9.7,10.6L9.7,10.6z M14.6,18.4c0,3.1-0.8,4.7-4.9,4.7H3.4v-7.9c0-1.1,0.4-1.5,1.5-1.5h4.8
            C12.8,13.8,14.6,14.5,14.6,18.4z"
      />
      <path
        fill="currentColor"
        d="M25,16c-2.2,0-3.5,0.3-4,0.4c-0.9,0.2-1.3,0.4-1.3,1.5v0.3c0,0.4,0.1,0.7,0.2,0.9c0.2,0.2,0.4,0.3,0.7,0.3
            c0.2,0,0.3,0,0.6-0.1c0.5-0.1,2.2-0.4,4-0.4c3.3,0,4.6,0.9,4.6,3.1v2h-4.1c-5.3,0-7.8,1.8-7.8,5.6s2.6,5.8,7.2,5.8
            c5.5,0,8-1.9,8-6.1V22C33,18,30.4,16,25,16z M29.8,26.6v2.6c0,2.1-0.8,3.3-4.8,3.3c-2.6,0-3.9-0.9-3.9-2.9c0-2.1,1.3-3,4.6-3H29.8z
            "
      />
      <path
        fill="currentColor"
        d="M51.2,16.9c-0.2-0.3-0.7-0.3-1.1-0.3h-0.3c-1.1,0-1.5,0.3-1.8,1.4l-3.1,12.8c-0.4,1.6-0.9,1.9-1.8,1.9
            c-1.1,0-1.6-0.3-2-1.9L37.6,18c-0.3-1.1-0.7-1.4-1.8-1.4h-0.3c-0.4,0-0.9,0-1.1,0.3c-0.2,0.3-0.2,0.7,0,1.2L37.9,31
            c0.7,2.5,1.4,4.5,4.4,4.5c0.5,0,1-0.1,1.5-0.2c-0.9,2.8-1.8,4-4.5,4.3c-0.5,0-0.9,0.1-1.1,0.4c-0.2,0.3-0.2,0.7-0.1,1l0.1,0.3
            c0.2,0.8,0.4,1.2,1.3,1.2c0.1,0,0.2,0,0.3,0c4-0.3,6.1-2.4,7.4-7.4l4.3-17C51.3,17.6,51.4,17.1,51.2,16.9L51.2,16.9z"
      />
      <path
        fill="currentColor"
        d="M78.8,8.9h-5.1c-0.6,0-1,0.4-1,1v0.7h0.4c2.3,0,3.1,0.4,3.1,2.5v3h2.6c0.6,0,1-0.4,1-1V9.9
            C79.8,9.3,79.4,8.9,78.8,8.9z"
      />
      <path
        fill="currentColor"
        d="M109.8,23.1c-0.9,0-1.4,0.2-1.7,0.5c-0.3,0.3-0.4,0.9-0.4,1.6v2.1c0,0.8,0.1,1.3,0.4,1.6
            c0.3,0.3,0.9,0.5,1.7,0.5s1.4-0.2,1.7-0.5c0.3-0.3,0.4-0.9,0.4-1.6v-2.1c0-0.8-0.1-1.3-0.4-1.6C111.3,23.3,110.7,23.1,109.8,23.1z"
      />
      <path
        fill="currentColor"
        d="M101.1,23.3h-1.8c-0.3,0-0.5,0.2-0.5,0.5v2.4h2.3c0.5,0,0.8-0.1,1-0.3c0.2-0.2,0.3-0.6,0.3-1.1
            s-0.1-0.8-0.3-1.1C102,23.4,101.6,23.3,101.1,23.3L101.1,23.3z"
      />
      <path
        fill="currentColor"
        d="M112.2,17.6H89.4c-4.8,0-8.8,3.9-8.8,8.8s3.9,8.8,8.8,8.8h22.7c4.8,0,8.8-3.9,8.8-8.8S117,17.6,112.2,17.6z
             M95.2,29.2c0,0.7-0.1,1.2-0.3,1.6c-0.2,0.3-0.6,0.5-1.3,0.6c-0.4,0.1-0.8,0.1-1.3,0.1c-1.7,0-2.9-0.3-3.7-0.9
            c-0.8-0.6-1.1-1.6-1.1-3v-2.4c0-1.2,0.4-2.1,1.2-2.8c0.8-0.7,2-1,3.5-1c0.7,0,1.4,0.1,2,0.3c0.3,0.1,0.6,0.2,0.7,0.4
            c0.1,0.1,0.2,0.4,0.2,0.7v0.1c0,0.4-0.1,0.6-0.2,0.7s-0.3,0.1-0.7,0c-0.6-0.2-1.3-0.3-1.9-0.3c-1,0-1.7,0.2-2.1,0.5
            s-0.6,0.9-0.6,1.7v2.4c0,0.6,0.2,1.1,0.6,1.4s1.1,0.5,2.1,0.5c0.2,0,0.4,0,0.6,0c0.3,0,0.4-0.2,0.4-0.5v-2.5c0-0.3,0.1-0.6,0.2-0.7
            s0.4-0.2,0.7-0.2h0.1c0.3,0,0.6,0.1,0.7,0.2s0.2,0.4,0.2,0.7L95.2,29.2L95.2,29.2z M101.2,28h-2.3v2.4c0,0.3-0.1,0.6-0.2,0.7
            s-0.4,0.2-0.7,0.2h-0.3c-0.4,0-0.6-0.1-0.7-0.2s-0.2-0.4-0.2-0.7v-7.2c0-0.6,0.1-1.1,0.4-1.4s0.8-0.4,1.4-0.4h2.5
            c2.3,0,3.4,1.1,3.4,3.3S103.4,28,101.2,28L101.2,28z M114,27.4c0,1.3-0.3,2.3-0.9,3s-1.7,1.1-3.3,1.1c-1.6,0-2.7-0.4-3.3-1.1
            c-0.6-0.7-0.9-1.7-0.9-3v-2.1c0-1.3,0.3-2.3,0.9-3s1.7-1.1,3.3-1.1c1.6,0,2.7,0.4,3.3,1.1c0.6,0.7,0.9,1.7,0.9,3V27.4z"
      />
    </g>
  </svg>
);

export default PayuLogo;
